import React from 'react';
import PropTypes from 'prop-types';
import { Phone } from '@mui/icons-material';

import './styles.scss';

const PhoneNumber = ({ phone }) => {
  const phoneCall = `tel: ${phone}`;

  return (
    <a href={phoneCall} className="phone-call">
      <Phone />
      {phone}
    </a>
  );
};

PhoneNumber.propTypes = {
  phone: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

PhoneNumber.defaultTypes = {
  phone: ''
};

export default PhoneNumber;
